import React from "react";
import {
  Paper,
  Stack,
  Typography,
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import RateReviewIcon from "@mui/icons-material/RateReview";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

/**
 * Plantillas de observaciones sugeridas para empleados generales.
 * Al hacer click se abre el TaskModal pre-cargado como tarea de observación
 * (categoría "documentation"). Son ejemplos editables, no datos reales.
 */
const SUGGESTIONS = [
  { title: "Shift handover note",        priority: "medium", hint: "Summary to pass to the next shift" },
  { title: "Equipment / supply issue",   priority: "high",   hint: "Report broken or missing supplies" },
  { title: "Front-desk / patient flow",  priority: "medium", hint: "Observation about wait times or flow" },
  { title: "Incident follow-up",         priority: "high",   hint: "Track an incident that needs follow-up" },
  { title: "General observation",        priority: "low",    hint: "Anything else worth noting" },
];

export default function SuggestedObservations({ onQuickCreate }) {
  return (
    <Paper
      elevation={0}
      sx={{ p: 2.5, borderRadius: 3, border: "1px solid", borderColor: "divider" }}
    >
      <Stack spacing={1.5}>
        {/* Header */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 28,
              height: 28,
              borderRadius: 1.5,
              bgcolor: "#F3E8FF",
              color: "#7C3AED",
            }}
          >
            <RateReviewIcon sx={{ fontSize: 16 }} />
          </Box>
          <Typography variant="subtitle2" fontWeight={700}>
            Suggested Observations
          </Typography>
        </Stack>

        <List dense disablePadding>
          {SUGGESTIONS.map((s) => (
            <ListItemButton
              key={s.title}
              onClick={() =>
                onQuickCreate({
                  title: s.title,
                  category: "documentation",
                  priority: s.priority,
                })
              }
              sx={{
                borderRadius: 2,
                mb: 0.5,
                border: "1px solid",
                borderColor: "divider",
                "&:hover": { borderColor: "#7C3AED", bgcolor: "#FAF5FF" },
              }}
            >
              <ListItemIcon sx={{ minWidth: 32, color: "#7C3AED" }}>
                <AddCircleOutlineIcon sx={{ fontSize: 18 }} />
              </ListItemIcon>
              <ListItemText
                primary={s.title}
                secondary={s.hint}
                primaryTypographyProps={{ fontSize: "0.82rem", fontWeight: 600 }}
                secondaryTypographyProps={{ fontSize: "0.68rem" }}
              />
            </ListItemButton>
          ))}
        </List>
      </Stack>
    </Paper>
  );
}
